import listCircle from '@/assets/list-circle.svg';
import colors from '@/design/colors';
import styled from 'styled-components';

export const Container = styled.div`
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;

  word-break: break-word;

  > div {
    display: flex;
    flex-direction: column;

    word-break: break-word;
  }

  /* General spacing */
  p,
  blockquote,
  ul,
  ol,
  dl,
  table,
  pre,
  details {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  /* Headings */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    font-weight: 600;
    line-height: 1.25;
  }

  h1 {
    font-size: 2em;
  }

  h2 {
    font-size: 1.5em;
  }

  h3 {
    font-size: 1.25em;
  }

  h4 {
    font-size: 1em;
  }

  h5 {
    font-size: 0.875em;
  }

  h6 {
    color: ${colors.gray100};
    font-size: 0.85em;
  }

  /* Code and Syntax Highlighting */
  pre {
    padding: 1rem;
    background-color: ${colors.gray100};
    border-radius: 6px;
    font-size: 85%;
    line-height: 1.45;
    overflow: auto;
  }

  pre code {
    line-height: inherit;
    overflow-wrap: normal;
    background-color: #0000;
    border: 0;
    margin: 0;
    padding: 0;
    display: inline;
    overflow: visible;
  }

  pre > code {
    word-break: normal;
    white-space: pre;
    background: 0 0;
    border: 0;
    margin: 0;
    padding: 0;
  }

  pre code {
    font-size: 100%;
  }

  code {
    white-space: break-spaces;
    background-color: ${colors.gray100};
    border-radius: 6px;
    margin: 0;
    padding: 0.2em 0.4em;
    font-size: 85%;
  }

  code {
    font-family: 'Anthropic Mono', ui-monospace, SFMono-Regular, SF Mono, Menlo,
      Consolas, Liberation Mono, monospace;
  }

  /* Tables */
  table {
    border: 1px solid ${colors.gray100};
    border-radius: 8px;
    border-spacing: 0px;

    th {
      padding: 12px 8px;
      &:first-child {
        border-top-left-radius: 8px;
      }
      &:last-child {
        border-top-right-radius: 8px;
      }

      text-align: left;
    }

    th,
    td {
      border: 1px solid ${colors.gray100};
      padding: 8px 32px 8px 8px;
    }

    tbody {
      tr {
        &:nth-child(2n + 1) {
          background: ${colors.whiteAlpha50};
        }
      }
    }

    tbody {
      tr {
        &:last-child {
          td {
            &:first-child {
              border-bottom-left-radius: 8px;
            }
            &:last-child {
              border-bottom-right-radius: 8px;
            }
          }
        }
      }
    }
  }

  /* Lists */
  ul,
  ol {
    padding-left: 1.5em;
    color: ${colors.gray300};
    list-style-position: outside;

    p {
      display: inline;
    }

    li {
      display: list-item;

      :not(:first-child) {
        margin-top: 0.5em;
      }
    }

    ul,
    ol {
      margin-top: 0.5em;
      margin-left: 1.5em;
    }
  }

  ul:not(.contains-task-list) {
    list-style-image: url(${listCircle});
    list-style-position: outside;
  }

  ul.contains-task-list {
    padding-left: 0;
    list-style: none;

    li.task-list-item {
      display: flex;
      align-items: center;
      list-style: none;
      margin-top: 0;

      input[type='checkbox'] {
        margin-right: 0.5em;
        margin-top: 0;
        margin-bottom: 0;
      }
    }
  }

  ol {
    list-style-type: decimal;
  }

  /* Blockquotes */
  blockquote {
    padding: 0.5em 1em;
    margin: 0.8em 0;
    border-left: 4px solid ${colors.gray100};
    color: ${colors.gray300};
    background-color: ${colors.gray50};
  }

  /* Horizontal Rule */
  hr {
    border: 0;
    border-bottom: 1px solid ${colors.gray100};
    background: 0 0;
    height: 0;
    margin: 15px 0;
    overflow: hidden;
  }

  /* Anchors */
  a {
    color: ${colors.purple100};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;
